import { MetadataBadge } from "./metadata-badge";

interface MetadataListProps {
  metadata: Record<string, string> | null | undefined;
  variant?: "full" | "compact";
  maxVisible?: number;
}

export const MetadataList = ({
  metadata,
  variant = "full",
  maxVisible = variant === "compact" ? 1 : undefined,
}: MetadataListProps) => {
  if (!metadata || Object.keys(metadata).length === 0) {
    return null;
  }

  const entries = Object.entries(metadata);
  const total = entries.length;
  const visibleEntries = maxVisible ? entries.slice(0, maxVisible) : entries;
  const remainingCount =
    maxVisible && total > maxVisible ? total - maxVisible : 0;

  if (variant === "compact") {
    return (
      <div className="flex flex-wrap items-center gap-1.5">
        {visibleEntries.map(([key, value]) => (
          <MetadataBadge
            key={key}
            label={key}
            value={value}
            variant="compact"
          />
        ))}
        {remainingCount > 0 && (
          <span className="text-[10px] text-muted-foreground">
            +{remainingCount}
          </span>
        )}
      </div>
    );
  }

  return (
    <div className="flex flex-wrap gap-2">
      {entries.map(([key, value]) => (
        <MetadataBadge key={key} label={key} value={value} />
      ))}
    </div>
  );
};
